// DEPRECATED
import createCompositor from '../createCompositor';
export default createCompositor;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/claygl@1.3.0/node_modules/claygl/src/compositor/createCompositor.js
// module id = null
// module chunks = 